import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SpreadsheetFile = function SpreadsheetFile(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? 'var(--color-primary-light-400)' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M35 40H13V23H35V40ZM15 38H33V25H15V38Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M34 28H14V30H34V28Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M34 33H14V35H34V33Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M25 24H23V39H25V24Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M42 45H6V4H30.4125L42 15.5875V45ZM8 43H40V16.4125L29.5875 6H8V43Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M41 17H29V5H31V15H41V17Z",
      fill: color
    })]
  });
};
export default SpreadsheetFile;